/**
 * Extracts redirect_url from URL query parameters
 * @returns redirect_url string or null if not found
 */
export const extractRedirectUrl = (): string | null => {
  const params = new URLSearchParams(window.location.search);
  const redirectUrl = params.get("redirect_url");

  return redirectUrl;
};
